import i18n from "@/i18n";
import store from "@/store";
import _ from "@/boot/lodash";
import { DataModules } from "@/store/modules/data";
import { HookCodes } from "@/data/enums/hooks";
import { createEventFunc, EventMapType } from "./utils";

const createEventMap: EventMapType = (hookId, payload = {}) => ({
  [hookId]: {
    name: i18n.t(`_hook.${hookId}_name`).toString(),
    event: event =>
      createEventFunc({
        ...payload,
        path: event?.object?.main_invoice_number
          ? `_hook.${hookId}`
          : `_hook.${hookId}_name`,
        slots: event => [
          ...((payload.slots && payload.slots(event)) || []),
          {
            slot: "orderId",
            is: "strong",
            message: `#${event?.object?.main_invoice_number}`,
            onClick: () => {
              store.dispatch(`data/${DataModules.ORDERS}/openPreviewModal`, {
                props: {
                  orderId: _.get(event, "object.main_invoice_id")
                }
              });
            }
          }
        ]
      })(event)
  }
});

export default {
  ...createEventMap(HookCodes.CONTRACT_CANCELLED),
  ...createEventMap(HookCodes.CONTRACT_ACTIVATED),
  ...createEventMap(HookCodes.CONTRACT_SUSPENDED),
  ...createEventMap(HookCodes.CONTRACT_CREATED, {
    icon: {
      name: "check-circle",
      type: "is-success"
    }
  }),
  ...createEventMap(HookCodes.CONTRACT_UPDATED_STATUS, {
    slots: event => [
      {
        slot: "id",
        is: "strong",
        message: event.object_id
      }
    ]
  }),
  ...createEventMap(HookCodes.ORDER_PLACED),
  ...createEventMap(HookCodes.CONTRACT_CLOSED),
  ...createEventMap(HookCodes.CONTRACT_UPDATED),
  ...createEventMap(HookCodes.CONTRACT_UNSUSPENDED),
  ...createEventMap(HookCodes.CONTRACT_AWAITING_ACTIVATION),
  ...createEventMap(HookCodes.CONTRACT_FAILED_RECURRING_PROCESSING),
  ...createEventMap(HookCodes.CONTRACT_COMPANY_ADDRESS_VAT_UPDATED)
};
